<template>
  <span class="ellipsis" :class="{ 'font-italic': valueOrFallback.isFallback }">{{ delimitedValue }}</span>
</template>

<script>
export default {
  props: ["source", "language", "field", "maxLength"],
  computed: {
    languageCode() {
      return this.language ? this.language.languageCode : "";
    },
    fallbackLanguageCode() {
      if (this.language) return this.language.fallbackLanguageCode;
      return "";
    },
    valueOrFallback() {
      const field = this.field || "name";
      if (this.source) {
        let model = this.source[this.languageCode];
        const value = model[field];
        if (value) return { value: value, isFallback: false };

        model = this.source[this.fallbackLanguageCode];
        if (model) return { value: model[field], isFallback: true };
      }
      return { value: "", isFallback: false, allEmpty: true };
    },
    delimitedValue() {
      if (this.maxLength && this.maxLength > 0 && this.valueOrFallback.value && this.valueOrFallback.value.length > this.maxLength)
        return this.valueOrFallback.value.substring(0, this.maxLength);
      return this.valueOrFallback.value;
    }
  }
};
</script>
